import React, { Component } from "react";
import FormContact from "../organisms/form-contact";
import FormWrapper from "../organisms/form-wrapper";
import FreeText from "../organisms/free-text";
import MyMap from "../molecules/map";

class sectionForm extends Component {
  constructor(props) {
    super(props);

    this.generalData = this.props?.generalData;
    this.dictionary = this.props?.dictionary;
    this.contactData = this.props?.contactData;
    this.contactIntro = this.props?.contactIntro;
    this.contactPageData = this.props?.contactPageData;
    this.renderMapAside = this.props?.renderMapAside;

    this.location = this.generalData?.contactLocation;
    this.markerText = this.generalData?.contactMarker;
    this.contactPageTitle = this.contactPageData?.pageTitle;

    this.state = {
      hideMap: false,
    };
  }

  formCallback = (dataFromChild) => {
    this.setState({
      hideMap: dataFromChild,
    });
  };

  render() {
    return (
      <section className="contact position-relative mt-5 pb-5">
        <div className="container-fluid">
          {this.contactIntro && <FreeText data={this.contactIntro} />}
          {this.contactPageTitle && (
            <div className="row py-5 bg-white">
              <div className="col-12 text-center">
                <h2>{this.contactPageTitle}</h2>
              </div>
            </div>
          )}
          <div className="row my-5 position-relative">
            <div className="col-12 col-xl-11 col-xxl-10 mx-auto">
              <FormWrapper callbackForMyMap={this.formCallback}>
                <FormContact className="" dictionary={this.dictionary} />
              </FormWrapper>
            </div>
            {!this.state.hideMap && (
              <div
                className={[
                  "embed-responsive",
                  "embed-responsive-21by9",
                  this.renderMapAside ? "embed-aside" : "",
                ].join(" ")}
              >
                <div className="embed-responsive-item">
                  <MyMap
                    location={this.location}
                    markerText={this.markerText}
                    zoom={17}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default sectionForm;
